import { TeamUserList, UserStatus } from '../../core/services/team-user.service';

export function isValidEmailFormat(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function formatUserDate(date: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).format(new Date(date));
}

export function getStatusText(status: UserStatus): string {
  switch (status) {
    case UserStatus.Active: return 'Active';
    case UserStatus.Pending: return 'Pending';
    case UserStatus.Inactive: return 'Inactive';
    case UserStatus.Deleted: return 'Deleted';
    default: return 'Unknown';
  }
}

export function processUsersData(
  users: TeamUserList[],
  roleDisplayName: (role: number) => string
): any[] {
  return users.map((user, index) => {
    const isPending = user.status === UserStatus.Pending;
    return {
      ...user,
      isInvite: isPending, // Pending users are considered invites
      originalUser: user,
      originalIndex: index,
      roleName: roleDisplayName(user.systemRole), // Show role for all users
      status: getStatusText(user.status),
      createdAt: formatUserDate(new Date(user.createdAt)),
      position: user.position || '-'
    };
  });
}

export function getBadgeSeverity(value: any): 'success' | 'info' | 'warn' | 'danger' | 'secondary' | 'contrast' {
  const stringValue = value?.toString()?.toLowerCase() || '';

  // Status badges
  switch (stringValue) {
    case 'active': return 'success';
    case 'pending': return 'warn';
    case 'inactive': return 'danger';
    case 'deleted': return 'danger';

    // Role badges
    case 'super administrator': return 'danger';
    case 'administrator': return 'info';
    case 'bim manager': return 'warn';
    case 'designer': return 'secondary';

    // Fallback
    default: return 'secondary';
  }
}
